import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/new',
    name: 'new',
    component: () => import(/* webpackChunkName: "about" */ '../views/New.vue')
  },
  {
    path: '/step1',
    name: 'Step1',
    component: () => import(/* webpackChunkName: "about" */ '../views/Step1.vue')
  },
  {
    path: '/leads',
    name: 'Leads',
    component: () => import(/* webpackChunkName: "about" */ '../views/Leads.vue')
  },
  {
    path: '/edit/:id',
    name: 'Edit',
    component: () => import(/* webpackChunkName: "about" */ '../views/Edit.vue')
  },
  {
    path: '/editstep1/:id',
    name: 'EditStep1',
    component: () => import(/* webpackChunkName: "about" */ '../views/EditStep1.vue')
  },
  {
    path: '/loanDetails/:id',
    name: 'loanDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/loanDetails.vue')
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reports.vue')
  },
  {
    path: '/bankloansanction',
    name: 'BankLoanSanction',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reports/BankLoanSanction/BankLoanSanction.vue')
  },
  {
    path: '/banknewreports',
    name: 'BankNewReports',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reports/BankNewReport/BankNewReports.vue')
  },
  {
    path: '/banknewreportdetails',
    name: 'BankNewReportDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reports/BankNewReport/BankNewReportDetails.vue')
  },
  {
    path: '/loanzreports',
    name: 'LoanzReports',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reports/LoanzReports/LoanzReports.vue')
  },
  {
    path: '/loanzdetailreports',
    name: 'LoanzDetailReports',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reports/LoanzReports/LoanzDetailReports.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
